// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import { DatePicker } from 'material-ui-pickers';
import CKeditor from 'ckeditor4-react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  crop: any;
  date: any;
  errors: Array<any>;
  product: any;
  users: any;
  products: any;
  employee: any;
  files: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  isFinished: boolean;
  isUpdating: boolean;
  key: any;
  text: any;
  textUpdated: any;
  title: any;
  toLocation: any;
  toDate: Date | null;
  profile_pic: any;
  croppedImage: any;
  src: any;
  croppedImageUrl: any;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class ArticleProfile extends React.Component<Props, State> {

  imageRef: null;

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      crop: {
        unit: "%",
        width: 100,
        aspect: 16 / 9
      },
      croppedImage: null,
      croppedImageUrl: null,
      date: this.formatDate(new Date()),
      employee: "",
      errors: [],
      files: "",
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      key: "",
      product: "",
      products: [],
      profile_pic: "",
      src: null,
      text: "",
      textUpdated: "",
      title: "",
      toDate: null,
      toLocation: "",
      users: []
    };
  }

  formatDate = (date: any) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1).toString();
    let day = '' + d.getDate().toString();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  async componentWillMount() {
    if (this.state.isUpdating) {
      await NetworkManager.request(`article/${this.props.match.params.id}`, MethodRequest_e.GET).then((article) => {
        this.setState({
          date: article.date,
          text: article.description,
          textUpdated: article.description,
          title: article.title
        });
      });
    }
  }

  padLeft(originalString: string, length: number, character: string): string {
    const numberChars: number = length - originalString.length;
    let completedString = originalString;

    //Iterate to add the number of specific character
    for (let i = 0; i < numberChars; i++) {
      completedString = character + completedString;
    }

    return completedString;
  }

  handleChange = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.value } as any);
    };
  }

  handleChangeSelect = (name: string): any => (value: string) => {
    this.setState({
      [name]: value
    } as any);
  }

  handleChangeCheck = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.checked } as any);
    };
  }

  handleFromDateChange = (date: Date) => {
    this.setState({ fromDate: date });
  }

  handleToDateChange = (date: Date) => {
    this.setState({ toDate: date });
  }

  updateContent = (newContent: any) => {
    this.setState({
      text: newContent
    });
  }

  handleFile = (e: any) => {
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({ src: fileReader.result });
    };
    fileReader.readAsDataURL(e.target.files[0]);
  }

  onImageLoaded = (image: any) => {
    this.imageRef = image;
  }

  onCropChange = (crop: any) => {
    this.setState({ crop });
  }

  onCropComplete = (crop: any) => {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = this.getCroppedImg(this.imageRef, crop);
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image: any, crop: any) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx: any = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    const reader = new FileReader();
    canvas.toBlob((blob: any) => {
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        this.setState({ croppedImage: reader.result });
      };
    }, "image/jpeg");
  }

  dataURLtoFile(dataurl: any, filename: any) {
    const arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const croppedImage = new File([u8arr], filename, { type: mime });
    this.setState({ croppedImage: croppedImage });
  }

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
      const errors: any = [];

      if (this.state.textUpdated == "" && this.state.text != "") {
        errors['text'] = "Ajouter un texte";
      }
      if (this.state.title == "") {
        errors['title'] = "Ajouter un titre";
      }
      if (this.state.date == "") {
        errors['date'] = "Ajouter un date";
      }

      this.setState({ errors: errors });

      const errorsNumber = Object.keys(errors).length;

      if (errorsNumber == 0) {
        MainStore.showOverlay(`${this.state.isUpdating ? "Modification" : "Création"} de l'article en cours...`);

        const formattedDate = this.formatDate(this.state.date);
        try {
          await NetworkManager.request(
            `article${this.state.isUpdating ? `/${this.props.match.params.id}` : ""}`,
            this.state.isUpdating ? MethodRequest_e.PUT : MethodRequest_e.POST, {
            date: formattedDate,
            description: this.state.textUpdated,
            title: this.state.title
          }).then((response) => {
            if (this.state.croppedImage != "" && this.state.croppedImage != null) {
              NetworkManager.request(`image/article/${response.id}`, MethodRequest_e.POST, {
                image: this.state.croppedImage
              });
            }
            MainStore.showNotification(response.text);
            MainStore.goBack(this.props.history.location.pathname);
            this.props.history.goBack();
          });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
      }
    };
  }

  addDefaultSrc = (ev: any) => {
    ev.target.className = 'hide';
  }

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {

    return (
      <Paper elevation={1} className="form-paper-container">
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          {this.state.isUpdating ? "Modification" : "Création"} d'une article</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              label="Titre"
              name="title"
              value={this.state.title}
              error={Boolean(this.state.errors['title'])}
              helperText={this.state.errors['title']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <DatePicker
              label="Date"
              name="date"
              format="DD.MM.YYYY"
              value={this.state.date}
              error={Boolean(this.state.errors['date'])}
              helperText={this.state.errors['date']}
              fullWidth={true}
              onChange={(date) => { this.setState({ date: date }); }} />
          </Grid>
          <Grid item={true} xs={12} className="form-field">
            <CKeditor name="editor-article" onBeforeLoad={(CKEDITOR: any) => (CKEDITOR.disableAutoInline = true)}
              data={this.state.text} onChange={(evt: any) => this.setState({ textUpdated: evt.editor.getData() })} />
          </Grid>
          <Grid item={true} xs={12} md={12} xl={12}>
            <input type='file' id='profile_pic' value={this.state.profile_pic}
              onChange={this.handleFile} />
            {this.state.src && (
              <ReactCrop
                src={this.state.src}
                crop={this.state.crop}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
            )}
          </Grid>
          <Grid item={true} xs={12} md={12} lg={12}>
            <img onError={this.addDefaultSrc}
              src={`${NetworkManager.getApiServer()}/img/article/${this.props.match.params.id}.jpg`} />
          </Grid>
        </Grid>
        <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>
          {this.state.isUpdating ? "Modifier" : "Créer"}
        </Button>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/ArticleProfile.tsx